import React from 'react';

interface GridContainerProps {
  singleColumn?: boolean;
  children: React.ReactNode;
  className?: string;
}

const GridContainer = ({ singleColumn = false, children, className }: GridContainerProps) => {
  const gridClass = singleColumn
    ? 'grid grid-cols-1 gap-4 w-full'
    : 'grid grid-cols-1 md:grid-cols-2 gap-4 w-full';

  return (
    <div className={className ? `${gridClass} ${className}` : gridClass}>
      {children}
    </div>
  );
};

export default GridContainer;
